// @ts-nocheck
// ====== UI: Le mie attività (to-do list personale) ======
// Si appoggia a todosApi (js/data/todos.js). Renderizza:
//   - 4 KPI (totale aperte / in scadenza 7gg / scadute / completate)
//   - filtri: stato, scadenza, ricerca testo
//   - lista card con bordo sx colorato secondo urgenza
//   - modal CRUD con titolo, descrizione, data scadenza, allegati drag&drop

// Cache locale tra render (per non interrogare il DB sui filtri)
let _todos = [];
let _editingId = null;
let _filterStato = 'aperte'; // tutte | aperte | completate
let _filterScadenza = 'all'; // all | scadute | oggi | settimana | senza
let _filterText = '';

function todoUrgencyKey(t) {
  if (t.completata) return 'done';
  if (!t.data_scadenza) return 'none';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(t.data_scadenza + 'T00:00:00');
  const diff = Math.floor((d - today) / 86400000);
  if (diff < 0) return 'overdue';
  if (diff === 0) return 'today';
  if (diff <= 3) return 'soon';
  if (diff <= 14) return 'week';
  return 'future';
}

function todoUrgencyLabel(key, t) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (key === 'done') return 'Completata';
  if (key === 'none') return 'Senza scadenza';
  const d = new Date(t.data_scadenza + 'T00:00:00');
  const diff = Math.floor((d - today) / 86400000);
  if (diff < 0) return `Scaduta ${-diff}gg fa`;
  if (diff === 0) return 'Scade oggi';
  if (diff === 1) return 'Scade domani';
  return `Tra ${diff}gg`;
}

function attachmentBytes(n) {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  return (n / 1024 / 1024).toFixed(1) + ' MB';
}

function attachmentIconSvg(mime) {
  // 3 categorie: immagine / pdf / generico
  if ((mime || '').startsWith('image/')) {
    return `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>`;
  }
  if (mime === 'application/pdf') {
    return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>`;
  }
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>`;
}

function getFilteredTodos() {
  const q = _filterText.toLowerCase().trim();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return _todos.filter((t) => {
    // stato
    if (_filterStato === 'aperte' && t.completata) return false;
    if (_filterStato === 'completate' && !t.completata) return false;

    // scadenza
    if (_filterScadenza !== 'all') {
      if (_filterScadenza === 'senza' && t.data_scadenza) return false;
      if (_filterScadenza !== 'senza') {
        if (!t.data_scadenza) return false;
        const d = new Date(t.data_scadenza + 'T00:00:00');
        const diff = Math.floor((d - today) / 86400000);
        if (_filterScadenza === 'scadute' && !(diff < 0)) return false;
        if (_filterScadenza === 'oggi' && !(diff === 0)) return false;
        if (_filterScadenza === 'settimana' && !(diff >= 0 && diff <= 7)) return false;
      }
    }

    // testo
    if (q) {
      const hay = (t.titolo + ' ' + (t.descrizione || '')).toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}

function renderTodoKpi() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let aperte = 0,
    scadute = 0,
    in7gg = 0,
    completate = 0;
  for (const t of _todos) {
    if (t.completata) {
      completate++;
      continue;
    }
    aperte++;
    if (t.data_scadenza) {
      const d = new Date(t.data_scadenza + 'T00:00:00');
      const diff = Math.floor((d - today) / 86400000);
      if (diff < 0) scadute++;
      else if (diff >= 0 && diff <= 7) in7gg++;
    }
  }
  const set = (id, n) => {
    const el = document.getElementById(id);
    if (el) el.textContent = n;
  };
  set('todoKpiAperte', aperte);
  set('todoKpiIn7gg', in7gg);
  set('todoKpiScadute', scadute);
  set('todoKpiCompletate', completate);

  const badge = document.getElementById('badgeTodos');
  if (badge) {
    const n = aperte;
    if (n > 0) {
      badge.classList.remove('hidden');
      badge.textContent = String(n);
    } else badge.classList.add('hidden');
  }
}

function renderTodoList() {
  const root = document.getElementById('todosList');
  if (!root) return;
  const list = getFilteredTodos();

  if (!list.length) {
    root.innerHTML = `
      <div class="todo-empty">
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor"
             stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 11l3 3 8-8"/>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
        <h3>Nessuna attività</h3>
        <p>${_todos.length ? 'Nessun match per i filtri attuali.' : 'Crea la tua prima attività con il pulsante "+ Nuova attività".'}</p>
        ${
          _todos.length
            ? '<button class="btn" id="todoClearFilters">Reset filtri</button>'
            : '<button class="btn btn-primary" id="todoAddFirst">+ Nuova attività</button>'
        }
      </div>`;
    const clearBtn = document.getElementById('todoClearFilters');
    if (clearBtn)
      clearBtn.addEventListener('click', () => {
        _filterStato = 'aperte';
        _filterScadenza = 'all';
        _filterText = '';
        $('#todoFilterStato').value = 'aperte';
        $('#todoFilterScadenza').value = 'all';
        $('#todoFilterSearch').value = '';
        renderTodoList();
      });
    const addBtn = document.getElementById('todoAddFirst');
    if (addBtn) addBtn.addEventListener('click', () => openTodoModal(null));
    return;
  }

  root.innerHTML = list
    .map((t) => {
      const urg = todoUrgencyKey(t);
      const due = t.data_scadenza ? fmtDate(t.data_scadenza) : '';
      const dueLabel = todoUrgencyLabel(urg, t);
      const desc = (t.descrizione || '').trim();
      const att = t.allegati || [];
      return html` <article
        class="todo-card todo-urg-${html.raw(urg)} ${t.completata ? html.raw('is-done') : ''}"
        data-id="${t.id}"
        tabindex="0"
      >
        <label class="todo-check" title="Segna come completata">
          <input type="checkbox" data-toggle="${t.id}" ${t.completata ? html.raw('checked') : ''} />
          <span aria-hidden="true"></span>
        </label>
        <div class="todo-main">
          <div class="todo-title-row">
            <h3 class="todo-title">${t.titolo}</h3>
            ${t.data_scadenza
              ? html.raw(
                  `<span class="todo-due-pill todo-due-${urg}" title="${escapeHtml(due)}">${escapeHtml(dueLabel)}</span>`
                )
              : ''}
          </div>
          ${desc
            ? html.raw(`<p class="todo-desc">${escapeHtml(desc).replace(/\n/g, '<br>')}</p>`)
            : ''}
          ${att.length
            ? html.raw(`
            <div class="todo-att-row">
              ${att
                .map(
                  (a) => `
                <button type="button" class="todo-att-chip" data-open-att="${escapeHtml(a.path)}" title="${escapeHtml(a.name)} · ${attachmentBytes(a.size)}">
                  ${attachmentIconSvg(a.mime)}
                  <span class="todo-att-name">${escapeHtml(a.name)}</span>
                </button>`
                )
                .join('')}
            </div>`)
            : ''}
        </div>
        <div class="todo-actions">
          <button
            class="btn-icon"
            data-edit="${t.id}"
            title="Modifica"
            aria-label="Modifica attività"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4z" />
            </svg>
          </button>
          <button
            class="btn-icon todo-del"
            data-del="${t.id}"
            title="Elimina"
            aria-label="Elimina attività"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
            </svg>
          </button>
        </div>
      </article>`;
    })
    .join('');

  // Wire up
  root.querySelectorAll('[data-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => e.stopPropagation());
    el.addEventListener('change', () => toggleTodo(el.dataset.toggle, el.checked));
  });
  root.querySelectorAll('[data-edit]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      openTodoModal(el.dataset.edit);
    });
  });
  root.querySelectorAll('[data-del]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      deleteTodo(el.dataset.del);
    });
  });
  root.querySelectorAll('[data-open-att]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      openAttachment(el.dataset.openAtt);
    });
  });
  // Click sulla card (non sui controlli) → apri modale modifica
  root.querySelectorAll('.todo-card').forEach((card) => {
    card.addEventListener('click', () => openTodoModal(card.dataset.id));
    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openTodoModal(card.dataset.id);
      }
    });
  });
}

async function renderTodos() {
  // KPI placeholder durante load (skeleton)
  const root = document.getElementById('todosList');
  if (root && !_todos.length) {
    root.innerHTML = `<div class="todo-loading">Caricamento attività…</div>`;
  }
  try {
    _todos = await todosApi.list();
  } catch (e) {
    console.error('Errore caricamento to-do:', e);
    toast('Errore nel caricamento delle tue attività');
    if (root)
      root.innerHTML = `<div class="todo-empty"><h3>Errore</h3><p>${escapeHtml(e.message || String(e))}</p></div>`;
    return;
  }
  renderTodoKpi();
  renderTodoList();
}

// ====== Modal CRUD ======

function openTodoModal(id) {
  _editingId = id || null;
  const modal = document.getElementById('modalTodo');
  if (!modal) return;
  const f = document.getElementById('formTodo');
  const t = id ? _todos.find((x) => x.id === id) : null;
  document.getElementById('modalTodoTitle').textContent = t
    ? 'Modifica attività'
    : 'Nuova attività';
  f.reset();
  f.titolo.value = t?.titolo || '';
  f.descrizione.value = t?.descrizione || '';
  f.data_scadenza.value = t?.data_scadenza || '';
  document.getElementById('todoModalCompleted').classList.toggle('hidden', !t);
  if (t) {
    document.getElementById('todoModalCompletedCheck').checked = !!t.completata;
  }
  renderTodoAttachmentsList(t);
  modal.classList.remove('hidden');
}

function closeTodoModal() {
  const m = document.getElementById('modalTodo');
  if (m) m.classList.add('hidden');
  _editingId = null;
}

function renderTodoAttachmentsList(t) {
  const root = document.getElementById('todoAttachmentsList');
  if (!root) return;
  const att = t?.allegati || [];
  const canUpload = !!_editingId; // upload disabilitato se non c'è ancora un todo salvato
  const help = canUpload
    ? 'Trascina qui un file, oppure clicca per sfogliare (max 10 MB).'
    : "Salva l'attività; poi riaprila con la matita per aggiungere allegati.";
  root.innerHTML = `
    <div class="todo-att-dropzone ${canUpload ? '' : 'is-disabled'}" id="todoAttDropzone" tabindex="0"
         role="button" aria-label="Trascina qui i file o clicca per sfogliare">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="17 8 12 3 7 8"/>
        <line x1="12" y1="3" x2="12" y2="15"/>
      </svg>
      <span class="todo-att-help">${escapeHtml(help)}</span>
      <input type="file" id="todoAttFile" class="hidden"
             accept="application/pdf,image/*,.docx,.xlsx,.pptx,.txt,.csv,.md,.zip">
    </div>
    ${
      att.length
        ? `
      <ul class="todo-att-list">
        ${att
          .map(
            (a) => `
          <li class="todo-att-item">
            <span class="todo-att-icon">${attachmentIconSvg(a.mime)}</span>
            <button type="button" class="todo-att-link" data-open-att="${escapeHtml(a.path)}" title="Apri">
              <span class="todo-att-item-name">${escapeHtml(a.name)}</span>
              <span class="todo-att-item-size">${attachmentBytes(a.size)}</span>
            </button>
            <button type="button" class="btn-icon todo-att-rm" data-rm-att="${escapeHtml(a.path)}"
                    title="Rimuovi allegato" aria-label="Rimuovi allegato">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </li>`
          )
          .join('')}
      </ul>`
        : ''
    }`;

  const dz = document.getElementById('todoAttDropzone');
  const fileInput = document.getElementById('todoAttFile');
  if (dz && fileInput && canUpload) {
    dz.addEventListener('click', () => fileInput.click());
    dz.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fileInput.click();
      }
    });
    dz.addEventListener('dragover', (e) => {
      e.preventDefault();
      dz.classList.add('is-drag');
    });
    dz.addEventListener('dragleave', () => dz.classList.remove('is-drag'));
    dz.addEventListener('drop', async (e) => {
      e.preventDefault();
      dz.classList.remove('is-drag');
      const files = [...(e.dataTransfer?.files || [])];
      for (const f of files) await uploadAttachment(f);
    });
    fileInput.addEventListener('change', async () => {
      const files = [...(fileInput.files || [])];
      for (const f of files) await uploadAttachment(f);
      fileInput.value = '';
    });
  }
  root.querySelectorAll('[data-rm-att]').forEach((el) => {
    el.addEventListener('click', () => removeAttachment(el.dataset.rmAtt));
  });
  root.querySelectorAll('[data-open-att]').forEach((el) => {
    el.addEventListener('click', () => openAttachment(el.dataset.openAtt));
  });
}

async function uploadAttachment(file) {
  if (!_editingId) return;
  try {
    toast(`Carico "${file.name}"…`);
    const updated = await todosApi.addAttachment(_editingId, file);
    // patch lista locale
    const idx = _todos.findIndex((t) => t.id === _editingId);
    if (idx >= 0) _todos[idx] = updated;
    renderTodoAttachmentsList(updated);
    renderTodoList();
    toast('Allegato caricato');
  } catch (e) {
    console.error(e);
    toast('Errore upload: ' + (e.message || e));
  }
}

async function removeAttachment(path) {
  if (!_editingId) return;
  const ok = await confirmAction({
    level: 'warning',
    title: "Rimuovere l'allegato?",
    message: "L'allegato verrà eliminato definitivamente.",
    confirmText: 'Rimuovi'
  });
  if (!ok) return;
  try {
    const updated = await todosApi.removeAttachment(_editingId, path);
    const idx = _todos.findIndex((t) => t.id === _editingId);
    if (idx >= 0) _todos[idx] = updated;
    renderTodoAttachmentsList(updated);
    renderTodoList();
    toast('Allegato rimosso');
  } catch (e) {
    toast('Errore: ' + (e.message || e));
  }
}

async function openAttachment(path) {
  try {
    const url = await todosApi.signedUrl(path);
    if (!url) {
      toast("Impossibile aprire l'allegato");
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch (e) {
    toast('Errore: ' + (e.message || e));
  }
}

async function saveTodoForm(e) {
  e.preventDefault();
  const f = document.getElementById('formTodo');
  const payload = {
    titolo: f.titolo.value.trim(),
    descrizione: f.descrizione.value.trim() || null,
    data_scadenza: f.data_scadenza.value || null
  };
  if (!payload.titolo) {
    toast('Inserisci un titolo');
    f.titolo.focus();
    return;
  }

  try {
    if (_editingId) {
      // include il flag completata se presente
      const compEl = document.getElementById('todoModalCompletedCheck');
      if (compEl) payload.completata = !!compEl.checked;
      const updated = await todosApi.update(_editingId, payload);
      const idx = _todos.findIndex((t) => t.id === _editingId);
      if (idx >= 0) _todos[idx] = updated;
      else _todos.unshift(updated);
      toast('Attività aggiornata');
    } else {
      const created = await todosApi.create(payload);
      _todos.unshift(created);
      toast('Attività creata');
    }
    closeTodoModal();
    renderTodoKpi();
    renderTodoList();
  } catch (e) {
    console.error(e);
    toast('Errore salvataggio: ' + (e.message || e));
  }
}

async function toggleTodo(id, completata) {
  try {
    const updated = await todosApi.toggleCompleted(id, completata);
    const idx = _todos.findIndex((t) => t.id === id);
    if (idx >= 0) _todos[idx] = updated;
    renderTodoKpi();
    renderTodoList();
  } catch (e) {
    toast('Errore: ' + (e.message || e));
    renderTodoList();
  }
}

async function deleteTodo(id) {
  const t = _todos.find((x) => x.id === id);
  if (!t) return;
  const ok = await confirmAction({
    level: 'danger',
    title: "Eliminare l'attività?",
    message: `"${t.titolo}" verrà eliminata definitivamente${(t.allegati || []).length ? ' insieme ai suoi allegati' : ''}.`,
    confirmText: 'Elimina'
  });
  if (!ok) return;
  try {
    await todosApi.remove(t);
    _todos = _todos.filter((x) => x.id !== id);
    renderTodoKpi();
    renderTodoList();
    toast('Attività eliminata');
  } catch (e) {
    toast('Errore: ' + (e.message || e));
  }
}

// ====== Init wiring (eventi una sola volta al load) ======
function initTodosWiring() {
  const newBtn = document.getElementById('btnNewTodo');
  if (newBtn) newBtn.addEventListener('click', () => openTodoModal(null));

  const form = document.getElementById('formTodo');
  if (form) form.addEventListener('submit', saveTodoForm);

  document
    .querySelectorAll('#modalTodo [data-close-todo]')
    .forEach((el) => el.addEventListener('click', closeTodoModal));

  const fs = document.getElementById('todoFilterStato');
  const fd = document.getElementById('todoFilterScadenza');
  const fq = document.getElementById('todoFilterSearch');
  if (fs)
    fs.addEventListener('change', () => {
      _filterStato = fs.value;
      renderTodoList();
    });
  if (fd)
    fd.addEventListener('change', () => {
      _filterScadenza = fd.value;
      renderTodoList();
    });
  if (fq)
    fq.addEventListener('input', () => {
      _filterText = fq.value;
      renderTodoList();
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTodosWiring);
} else {
  initTodosWiring();
}

Object.assign(globalThis, {
  renderTodos,
  openTodoModal,
  closeTodoModal,
  toggleTodo,
  deleteTodo,
  openAttachment
});
export {};
